/**
 * LoadMore Module.
 *
 * This will handle any bound events and callbacks
 * for the timeline.
 *
 * This will be loaded with the the namespace: timeline.
 *
 * @param data
 * @returns {boolean}
 */

/**
 * Require jQuery.
 */
var $ = require('jquery');
var rest = require('./rest');
var ads = require('./ads');

/**
 * Extend jQuery so we can set a button to
 * disabled after there are no more pages to load.
 */
$.fn.extend({
    disable: function (state) {
        return this.each(function () {
            this.disabled = state;
        });
    }
});

/**
 * Derived list callback.
 *
 * Process to update the DOM with the rest call results.
 *
 * 1. Get the data json object
 * 2. Append markup to the results element.
 * 3. If there isn't a next page, the deavtivate the button.
 *
 * @param data The json object from the rest call.
 *
 */
var derivedListCallback = function (data) {

    var parent_elem = data.query.domID;
    $(parent_elem + ' .results').append(data.markup);
    if (false === data.next_page) {
        $(parent_elem + ' .load-more-button').disable(true);
    }

};

var topicChannelListCallback = function (data) {

    var parent_elem = data.query.domID;
    $(parent_elem + ' .results').append(data.markup);
    if (false === data.next_page) {
        $('.load-more-button').disable(true);
    }
    ads.updateAds();

};

var industryChannelListCallback = function (data) {

    var parent_elem = data.query.domID;
    $(parent_elem + ' .results').append(data.markup);
    if (false === data.next_page) {
        $('.load-more-button').disable(true);
    }
    ads.updateAds();

};

/**
 * Derived module lists load more event.
 *
 * This will trigger a derived load more rest call by:
 *
 * 1. Attach a click event to any element with
 * the classes: ".derived.load-more-button"
 *
 * 2. Get the current load more button text.
 *
 * 3. Set the loading text.
 *
 * 4. Find the parent DOM elemnt with the
 * class ".load-more" - This will be the element
 * with the data-query and data-page attributes
 * we need for the query.
 *
 * 5. Increment the data-page attribute so we know
 * what the next page will be for the query.
 *
 * 6. Set the data-query to a query variable so
 * we can alter it.
 *
 * 7. Add a query.page property with the next page.
 *
 * 8. Add a query.domID property to have the id
 * of the parent, load-more container.
 *
 * 6. Set the handlers for the loading text.
 *
 * 7. Make the rest call.
 *
 */
var derivedList = function () {
    $('.derived.load-more-button').click(function () {

        var button = this;
        var initial_text = $(button).text();
        var loading_text = 'Loading...';
        var $parent = $(this).closest('.load-more');

        var next_page = $parent.data('page') + 1;
        $parent.data('page', next_page);

        var query = $parent.data('query');
        query.page = next_page;
        query.domID = '#' + $parent.attr('id');

        $(document).on({
            ajaxStart: function () {
                $(button).html(loading_text);
            },
            ajaxStop: function () {
                $(button).html(initial_text);
            }
        });

        rest.postJson('/wp-json/ir/v1/post/derived-list', query, derivedListCallback);

    });
};

var topicChannelList = function () {
    $('.topic-channel.load-more-button').click(function () {

        var button = this;
        var initial_text = $(button).text();
        var loading_text = 'Loading...';
        var $parent = $('#topic-posts');

        var next_page = $parent.data('page') + 1;
        $parent.data('page', next_page);

        var query = $parent.data('query');
        query.page = next_page;
        query.domID = '#topic-posts';

        $(document).on({
            ajaxStart: function () {
                $(button).html(loading_text);
            },
            ajaxStop: function () {
                $(button).html(initial_text);
            }
        });

        rest.postJson('/wp-json/ir/v1/post/topic-channel-list', query, topicChannelListCallback);

    });
};

var industryChannelList = function () {
    $('.industry-channel.load-more-button').click(function () {

        var button = this;
        var initial_text = $(button).text();
        var loading_text = 'Loading...';
        var $parent = $('#industry-posts');

        var next_page = $parent.data('page') + 1;
        $parent.data('page', next_page);

        var query = $parent.data('query');
        query.page = next_page;
        query.domID = '#industry-posts';

        $(document).on({
            ajaxStart: function () {
                $(button).html(loading_text);
            },
            ajaxStop: function () {
                $(button).html(initial_text);
            }
        });

        rest.postJson('/wp-json/ir/v1/post/industry-channel-list', query, industryChannelListCallback);

    });
};

/**
 * Methods to execute immediately.
 */
var init = function () {
    derivedList();
    topicChannelList();
    industryChannelList();
};

/**
 * Export all of the methods.
 */
module.exports = {
    init: init,
    derivedListCallback: derivedListCallback,
    topicChannelListCallback: topicChannelListCallback,
    industryChannelListCallback: industryChannelListCallback
};
